<template>
    <div class="biz-wallet-info">
        <modal :display="modalStatus.bizWalletStoredInfo" @modalStatus="closeModal" >
            <h1>儲值</h1>
            <div class="content">
                <div class="pay-way">
                    <div>選擇付款方式：</div>
                    <div class="type">
                        <img src="@/assets/img/icon/atm_orange.svg" alt="" srcset="">
                        <div class="content-wrap">
                            <div class="title">
                                匯款帳號
                            </div>
                        </div>
                    </div>
                </div>
                <div class="notice-content">注意事項：下列是您個人的專屬匯款帳號，請到銀行進行匯款即可完成儲值。</div>
                <div class="list-wrap">
                    <div class="list">
                        <span class="title">銀行名稱</span>
                        <span class="info">：{{userStoredInfo.bankName}}</span>
                    </div>
                    <div class="list">
                        <span class="title">銀行代號</span>
                        <span class="info">：{{userStoredInfo.bankCode}}</span>
                    </div>
                    <div class="list">
                        <span class="title">匯款帳號</span>
                        <span class="info">：{{userStoredInfo.bankAccount}}</span>
                    </div>
                    <div class="list">
                        <span class="title">金額幣別</span>
                        <span class="info">：{{userStoredInfo.currencyType}}</span>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
        }
    },
    // mounted() {
    //     this.$analytics.logEvent('新增委託_ATM付款', { screen_name: '新增委託_ATM付款'})
    // },
    watch: {
        'modalStatus.bizWalletStoredInfo': {
            handler: function (val) {
                if(val){
                    console.log(val)
                    this.$store.dispatch('getBizWalletAccount')
                }
            },
            immediate: true
        }
    },
    methods: {
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizWalletStoredInfo'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
            userStoredInfo: 'GET_BIZ_STORED_INFO'
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    .biz-wallet-info{
        .modal-content{
            width: 456px;
            padding: 0 !important;
            .detail{
                align-items: unset !important;
                padding: 32px 0;
                h1{
                    font-size: 24px;
                    margin: 0 auto;
                    margin-bottom: 24px;
                }
                .content{
                    padding: 0 32px;
                    .pay-way{
                        display: flex;
                        align-items: center;
                        margin-bottom: 24px;
                        .type{
                            display: flex;
                            align-items: center;
                            padding: 0 20px;
                            width: 121px;
                            height: 90px;
                            border-radius: 4px;
                            border: solid 1px#ff9275;
                            background-color: #fff;
                            line-height: 1.71;
                            color: #ff9275;
                            margin-right: 16px;
                            img{
                                margin-right: 10px;
                            }
                            .content-wrap{
                                .description{
                                    font-size: 12px;
                                }
                            }
                        }
                    }
                    .notice-content{
                        color: #ff9275;
                        margin-bottom: 16px;
                    }
                    
                    .list{
                        margin-bottom: 12px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/walletStoredInfo.vue